import styled from '@emotion/styled';
import { rem } from '@utils';

const Shell = styled.main`
  background: var(--right-panel-background-color);
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: ${rem(14)};
  grid-area: d;
  grid-column: 2 / 4;
  min-height: 0;
  min-width: 0;
  width: 100%;
  z-index: 0;

  @media (max-width: 768px) {
    grid-column: 1;
  }
`;

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-inline: auto;
  max-width: ${rem(1200)};
  min-height: 0;
  overflow: hidden auto;
  overscroll-behavior: none;
  padding: ${rem(24)} ${rem(24)} ${rem(64)} ${rem(24)};
  width: 100%;

  && {
    scrollbar-gutter: initial;
  }

  @media (max-width: 430px) {
    padding: ${rem(16)};
  }
`;

const ArtifactCapture = styled.div`
  background: var(--right-panel-background-color);
  display: block;
  width: 100%;
`;

export default { ArtifactCapture, Content, Shell };
